import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { formatDate, formatDateTime } from 'utils/Formatters';
import { find, isEmpty, map, groupBy } from 'lodash';
import { loadPlayersFiltersByIds } from 'actions';
import ASQ_SE2Logo from '/assets/images/asq_se2-logo.svg';
import ASQ_3Logo from '/assets/images/asq_3-logo.svg';

const ASQ_TYPE_LOGOS = {
  "asq_se2": ASQ_SE2Logo,
  "asq_3": ASQ_3Logo,
}

const asqTypeLogo = (asqType) => {
  return ASQ_TYPE_LOGOS[asqType];
}

class AsqSurveysReportDetailsModal extends React.Component {
  componentDidMount() {
    this.loadPlayer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.report.player == this.props.report.player) return;

    this.loadPlayer();
  }

  loadPlayer() {
    if (!this.props.report) return;
    if (!this.props.report.player) return;

    this.props.loadPlayersFilters([this.props.report.player]);
  }

  render() {
    const {report} = this.props

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('reports.details.title')}</b></h2>
        <hr className='u-margin-top--zero'/>
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>{this.props.t('reports.details.asqType')}</th>
              <td>
                <img style={{height: "1.4rem", marginLeft: "0.4rem"}} src={asqTypeLogo(report.params.asq)} alt={report.params.asq} />
              </td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.requestedAt')}</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.teachers')}</th>
              <td>{this.renderRelated('teachers')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.groups')}</th>
              <td>{this.renderRelated('groups')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.cohorts')}</th>
              <td>{this.renderCohorts()}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.player')}</th>
              <td>{this.renderRelated('player', 'players')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.onlyMostRecent')}</th>
              <td>{report.params.recent ? this.props.t('reports.details.yes') : this.props.t('reports.details.no')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRelated(attribute, collectionName) {
    const collection = this.props[collectionName || attribute];

    return this.relatedIds(attribute).map((id) => {
      const item = find(collection, p => p.value == id)
      return item ? item.label : null;
    }).join(', ');
  }

  relatedIds(relatedAttribute) {
    const {report} = this.props;

    if (isEmpty(report.params[relatedAttribute])) { return [] }

    return report.params[relatedAttribute].split(',').map((id) => {
      return parseInt(id, 10);
    })
  }

  renderCohorts() {
    return map(this.groupedReportCohorts(), (cohorts, groupName) => {
      return (
        <div key={groupName}>
          {
            [
              groupName,
              cohorts.map(c => c.name).join(", "),
            ].join(": ")
          }
        </div>
      )
    });
  }

  groupedReportCohorts() {
    return groupBy(this.reportCohorts(), 'group_name');
  }

  reportCohorts() {
    return this.relatedIds("cohorts").map((id) => {
      return find(this.cohorts(), p => p.id == id)
    });
  }

  cohorts() {
    return map(this.props.cohorts, (group, groupName) => { return group }).flat();
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlayersFilters: (ids) => {
      dispatch(loadPlayersFiltersByIds(ids));
    }
  }
}

const mapStateToProps = (state) => {
  return {
    teachers: state.filters.teachers,
    groups: state.filters.groups,
    cohorts: state.filters.cohorts,
    players: state.filters.players,
  }
}

AsqSurveysReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
  teachers: PropTypes.arrayOf(PropTypes.object).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  cohorts: PropTypes.object.isRequired,
  players: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AsqSurveysReportDetailsModal))
